import React from 'react';
// @ts-ignore
import EnllacComponent from 'components/corporatiu/Enllac/Enllac';
// @ts-ignore
import { Pestanyes as PestanyesComponent, Pestanya as PestanyaComponent } from 'components/corporatiu/Pestanyes/Pestanyes';
import styles from './publicacionsmarato.module.scss';
import type { MemoriaItem, RevistaItem } from './PublicacionsMarato.types';

const Enllac = EnllacComponent as React.ComponentType<{
    href?: string;
    title?: string;
    novaFinestra?: boolean;
    children: React.ReactNode;
}>;

const Pestanyes = PestanyesComponent as React.ComponentType<{
    estil?: string;
    children: React.ReactNode;
}>;

const Pestanya = PestanyaComponent as React.ComponentType<{
    titol: string;
    activa?: boolean;
    children: React.ReactNode;
}>;

interface PublicacionsMaratoProps {
    memories?: MemoriaItem[];
    revistes?: RevistaItem[];
}

const PublicacionsMarato = ({ memories = [], revistes = [] }: PublicacionsMaratoProps) => (
    <Pestanyes estil='marato'>
        <Pestanya titol="MEMÒRIA D'ACTIVITATS" activa={true}>
            <p className={styles.intro}>
                L&apos;edició anual de la <strong>Memòria d&apos;activitats</strong> de la Fundació, que compta amb el suport de
                Fundació Abertis, permet fer un ampli repàs del conjunt d&apos;activitats i dels resultats econòmics obtinguts
                durant cada exercici comptable. A més, en aquesta Memòria es pot trobar informació detallada de les convocatòries
                del concurs d&apos;ajuts, del procés d&apos;avaluació dels projectes de recerca presentats al concurs, així com
                els resultats científics obtinguts un cop finalitzats els treballs de recerca, entre d&apos;altres aspectes.
            </p>
            <ul className={styles.blocList}>
                {Array.isArray(memories) &&
                    memories.map((item) => (
                        <li key={item.id} className={styles.publicacio}>
                            <Enllac href={item.href} title={item.alt}>
                                <img loading='lazy' src={item.img} width={168} height={236} alt={item.alt} />
                                <div className={styles.pdf}>{item.text}</div>
                            </Enllac>
                        </li>
                    ))}
            </ul>
        </Pestanya>
        <Pestanya titol='REVISTA MÓN MARATÓ'>
            <p className={styles.intro}>
                La Fundació edita la revista <strong>Món Marató</strong> el mes de desembre, abans de cada edició de La Marató.
                Amb aquesta publicació es dóna àmplia informació del contingut del programa La Marató, de la campanya de
                sensibilització i de difusió, dels resultats econòmics obtinguts, i molts altres aspectes relacionats amb el
                programa televisiu i amb la gestió dels recursos recaptats.
            </p>
            <ul className={styles.blocList}>
                {Array.isArray(revistes) &&
                    revistes.map((item) => (
                        <li key={item.id} className={styles.publicacio}>
                            <Enllac href={item.href} title={item.alt} novaFinestra={true}>
                                <img loading='lazy' src={item.img} width={168} height={236} alt={item.alt} />
                                <div className={styles.pdf}>{item.text}</div>
                            </Enllac>
                            {item.data && <div className={styles.textTerciari}>{item.data}</div>}
                        </li>
                    ))}
            </ul>
        </Pestanya>
    </Pestanyes>
);

export default PublicacionsMarato;
